<!-- <div class="sticky-top">
  <app-header></app-header>
</div> -->
<div class="container-fluid">
  <luv-dorpel #dorpel [checkOtherFormsValidity]="checkOtherFormsValidity.bind(this)"></luv-dorpel>
  <div *ngIf="!isDorpelConfigurationDisabled"> <!-- PRODUCTION-PATCH: remove this wrapper once HS up to par-->
    <luv-neuten #neuten></luv-neuten>
    <luv-sluitpotten #sluitpotten></luv-sluitpotten>
    <app-bewerkingen-horiz #bewerkingen *ngIf="showBewerkingen"></app-bewerkingen-horiz>
    <div class="container bg-white py-4 rounded-4 text-center">
      <div [formGroup]="formGroup" class="row justify-content-center">
        <div class="col-sm-12">
          <label for="opmerking" class="form-label"><b>Opmerkingen</b></label>
          <textarea class="form-control" id="opmerking" rows="3" formControlName="dorpelOpmerking"></textarea>
        </div>
      </div>
      <br />
      <div *ngIf="invalidComponentsMessage" class="row justify-content-center invalid-components-message">
        {{invalidComponentsMessage}}</div>
      <div class="row justify-content-center">
        <div class="justify-content-center btn-group" role="group">
          <button class="action-button btn btn-secondary btn-lg gap-0 border-1 rounded-10"
            (click)="abortCurrentConfiguration()">
            <b>Terug</b>
          </button>
          <button *ngIf="viewMode === 'Add'" type="button" class="action-button btn btn-secondary btn-lg gap-0 border-1 rounded-10"
            (click)="clearData()"><b>Wissen</b></button>
          <button type="button" class="action-button btn btn-secondary btn-lg px-4 gap-0 border-1 rounded-10"
            (click)="addToCardAndClearData()"><b>{{addToCartAndClearButtonLabel}}</b></button>
          <button type="button" class="action-button btn btn-secondary btn-lg px-4 gap-0 border-1 rounded-10"
            (click)="addToCart()"><b>{{addToCartButtonLabel}}</b></button>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="isDorpelConfigurationDisabled"> <!-- PRODUCTION-PATCH: remove this content once HS up to par-->
    <div class="row justify-content-center">
      <div>
        <div class="col-xl-12">
          <p>We zijn momenteel bezig met onderhoud met betrekking tot de hefschuifdorpels.</p>
          <h6>Bestelformulieren aluminium onderdorpels</h6>
          <ol>
            <li><a
                href="http://www.luvema.nl/upload/file/quick/Bestelformulier%20(70)%20Onderdorpels%20hefschuifdeuren%20Schema-A.pdf"
                target="_blank">hefschuif schema A</a></li>
            <li><a
                href="http://www.luvema.nl/upload/file/quick/Bestelformulier%20(71)%20Onderdorpels%20hefschuifdeuren%20Schema-C&G.pdf"
                target="_blank">hefschuif schema C & G</a></li>
            <li><a
                href="http://www.luvema.nl/upload/file/quick/Bestelformulier%20(72)%20Onderdorpels%20hefschuifdeuren%20Schema-D.pdf"
                target="_blank">hefschuif schema D</a></li>
            <li><a
                href="http://www.luvema.nl/upload/file/quick/Bestelformulier%20(73)%20Onderdorpels%20hefschuifdeuren%20SPECIALS.pdf"
                target="_blank">hefschuif specials</a></li>
          </ol>
          <h6>Bestelformulieren ISOWEL Onderdorpels</h6>
          <ol>
            <li>hefschuif schema A - <a
                href="http://luvema.nl/upload/file/Bestelformulier%20IW-HS%20schema%20A%20-%202023(1).pdf"
                target="_blank">HS140 / 146</a> of <a
                href="http://luvema.nl/upload/file/order-forms/Bestelformulier%20IW-HS190%20schema%20A%20-%202023%20(1).pdf"
                target="_blank">HS190</a></li>
            <li>hefschuif schema C & G - <a
                href="http://luvema.nl/upload/file/Bestelformulier%20IW-HS%20schema%20C%20%2B%20G%20-%202023(1).pdf"
                target="_blank">HS140 / 146</a> of <a
                href="http://luvema.nl/upload/file/order-forms/Bestelformulier%20IW-HS190%20schema%20C%20%2B%20G%20-%202023%20(1).pdf"
                target="_blank">HS190</a></li>
            <li>hefschuif special - <a
                href="http://luvema.nl/upload/file/Bestelformulier%20IW-HS%20special%20-%202023(1).pdf"
                target="_blank">HS140 / 146</a> of <a
                href="http://luvema.nl/upload/file/order-forms/Bestelformulier%20IW-HS190%20special%20-%202023.pdf"
                target="_blank">HS190</a></li>
          </ol>
          <div>
            <div>Telefoon: +31(0)317-612878</div>
            <div>Email: <a href="mailto:info@luvema.nl">info@luvema.nl</a></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>